export const formatUSDate = (date) => {
    return date ? date.slice(5, 7) + '/' + date.slice(8, 10) + '/' + date.slice(0, 4) : null
}